<div class="formulario">
  <div class="container">
    <form class="myForm" [formGroup]="proveedorForm" (ngSubmit)="onSubmit()"(keydown.enter)="$event.preventDefault()">
      <div class="container">

        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Nombre</label>
              <input class="form-control" type="text" formControlName="nombre">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Abreviatura</label>
              <input class="form-control" type="text" formControlName="abv">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Código Contable</label>
              <input class="form-control" type="text" formControlName="codigo">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">DNI/CIF</label>
              <input class="form-control" type="text" formControlName="cif">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Dirección</label>
              <input class="form-control" type="text" formControlName="direccion">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">C.P.</label>
              <input class="form-control" type="text" formControlName="cp">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">País</label>
              <p-dropdown [options]="countries" formControlName="pais"  (onChange)="getProvinces($event)"></p-dropdown>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Provincia</label>
              <p-dropdown [options]="provinces" formControlName="provincia" (onChange)="getCities($event)"></p-dropdown>
            </div>
          </div>
         
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Localidad</label>
              <p-dropdown [options]="cities" formControlName="localidad"></p-dropdown>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Teléfono</label>
              <input class="form-control" type="text" formControlName="telefono">
            </div>
          </div>          
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Email</label>
              <input class="form-control" type="text" formControlName="email">
            </div>
          </div>          
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Pasaporte fitosanitario</label>
              <input class="form-control" type="text" formControlName="pasaporte_fito">
            </div>
          </div>          
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Precio transporte</label>
              <input class="form-control alider" type="number" formControlName="precio_transporte">
            </div>
          </div>          


        </div>

      </div>
      <br>

      <div class="botones">
        <button type="button" class="btn btn-warning" (click)="regresar()"><i class="fa fa-chevron-left"
            aria-hidden="true"></i> Volver</button>
        <button type="submit" class="btn btn-success" [disabled]="proveedorForm.invalid || noGrabar"><i
            class="fa fa-save" aria-hidden="true"></i> Enviar</button>
      </div>      

    </form>
  </div>
</div>
<p-toast [style]="{marginTop: '80px'}"></p-toast>
